import type { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { StyledH5 } from '../../../stylesNew'
import { getMapBaseLayers, MapBaseLayer } from '../../../utils/map'
import useParam from '../../../hooks/useParam'
import { BaseLayer, baseLayerParam } from '../../../../pages/MapPage/query-params'
import { Menu, MenuButton } from './Menu'

const aerialLayers = getMapBaseLayers('aerial').filter(({ infraRed }) => !infraRed)

const infraRedLayers = getMapBaseLayers('aerial').filter(({ infraRed }) => infraRed)

const topoLayers = getMapBaseLayers('topography')

const StyledBorder = styled.span<{ $active: boolean }>`
  border-radius: 6px;
  height: 1.5rem;
  width: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.5rem;

  img {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 6px;
  }
  ${({ $active }) =>
    $active &&
    css`
      border: 2px var(--blue) solid;
      img {
        width: 1rem;
        height: 1rem;
        border-radius: 4px;
      }
    `}
`

const StyledList = styled.ul`
  display: flex;
  gap: 0 2.5em;
  flex-wrap: wrap;
`

interface BorderedImageProps {
  layer: MapBaseLayer
  activeBaseLayer: BaseLayer
  imageUrl?: string
}
const BorderedImage: FunctionComponent<BorderedImageProps> = ({
  layer,
  activeBaseLayer,
  imageUrl,
}) => {
  return (
    <StyledBorder $active={layer.id === activeBaseLayer}>
      {(layer?.imageUrl || imageUrl) && <img src={layer?.imageUrl ?? imageUrl} alt={layer.label} />}
    </StyledBorder>
  )
}

interface TopoMenuProps {
  setTopoMenu: (topoMenu: boolean) => void
  setSelectedLayer?: (layer: MapBaseLayer) => void
}

const TopoMenu: FunctionComponent<TopoMenuProps> = ({ setTopoMenu, setSelectedLayer }) => {
  const [activeBaseLayer, setActiveBaseLayer] = useParam(baseLayerParam)

  const handleSetBaseLayer = (layer: MapBaseLayer) => {
    setActiveBaseLayer(layer.id as BaseLayer, 'replace')
    if (setSelectedLayer) {
      setSelectedLayer(layer)
    }
    setTopoMenu(false)
  }

  return (
    <Menu className="topo">
      <StyledH5>Topografie</StyledH5>
      <StyledList>
        {topoLayers.map((layer) => {
          return (
            <MenuButton key={layer.id} handleClick={() => handleSetBaseLayer(layer)}>
              <BorderedImage layer={layer} activeBaseLayer={activeBaseLayer} />
              {layer.label}
            </MenuButton>
          )
        })}
      </StyledList>

      <StyledH5>Luchtfoto&apos;s</StyledH5>
      <p>Kleur (RGB)</p>
      <StyledList>
        {aerialLayers.map((layer) => {
          return (
            <MenuButton key={layer.id} handleClick={() => handleSetBaseLayer(layer)}>
              <BorderedImage
                layer={layer}
                activeBaseLayer={activeBaseLayer}
                imageUrl="/assets/images/topo/aerial.png"
              />
              {layer.label.slice(-4)}
            </MenuButton>
          )
        })}
      </StyledList>

      <p>Infrarood (CIR)</p>
      <StyledList>
        {infraRedLayers.map((layer) => {
          return (
            <MenuButton key={layer.id} handleClick={() => handleSetBaseLayer(layer)}>
              <BorderedImage
                layer={layer}
                activeBaseLayer={activeBaseLayer}
                imageUrl="/assets/images/topo/infrared.png"
              />
              {layer.label.slice(-4)}
            </MenuButton>
          )
        })}
      </StyledList>
    </Menu>
  )
}

export default TopoMenu
